export function formatMisroutedDescriptorSaveMessage(billedAlertsCount?: number): string {
  if (billedAlertsCount === undefined) return 'Descriptor marked as misrouted.';
  return `Descriptor marked as misrouted. ${billedAlertsCount} alert${billedAlertsCount === 1 ? '' : 's'} billed.`;
}
